<template>
  <form @submit.prevent="terminarVenta">
    <div class="modal-card" style="width: 600px">
      <header class="modal-card-head has-background-success">
        <p class="modal-card-title has-text-white">Terminar venta</p>
        <button type="button" class="delete" @click="$emit('close', 'venta')" />
      </header>
      <section class="modal-card-body">
        <busqueda-cliente @seleccionado="onSeleccionado" :initialCliente="cliente.nombre ? cliente : null" />
        <div class="mb-2">
          <label class="label">Métodos de pago</label>
          <div v-for="(pago, index) in pagos" :key="index"
            class="columns is-vcentered is-mobile mb-1">
            <div class="column">
              <b-select class="wide" placeholder="Seleccionar..." icon="tag-multiple"
                v-model="pago.idMetodo" :required="true">
                <option v-for="metodo in metodos" :key="metodo.id" :value="metodo.id">
                  {{ metodo.nombre }}
                </option>
              </b-select>
            </div>
            <div class="column">
              <b-input type="number" step="0.01" icon="currency-usd"
                placeholder="Monto" v-model="pago.monto" required></b-input>
            </div>
            <div class="column is-narrow" v-if="pagos.length > 1">
              <b-button type="is-danger" icon-left="close" size="is-small"
                @click="quitarPago(index)"></b-button>
            </div>
          </div>
          <b-button type="is-info" size="is-small" icon-left="plus"
            @click="agregarPago" :disabled="pagos.length >= 5">
            Agregar método de pago
          </b-button>
        </div>

        <!-- Running total vs total a pagar -->
        <div v-if="pagos.length > 0" class="mb-2">
          <p class="has-text-weight-semibold">
            Total ingresado:
            <span :class="totalPagosColor">
              ${{ formatoMonto(totalPagosCalculado) }}
            </span>
            <span v-if="diferenciaPagos !== 0" :class="totalPagosColor">
              ({{ diferenciaPagos > 0 ? 'Excede' : 'Faltan' }}
              ${{ formatoMonto(Math.abs(diferenciaPagos)) }})
            </span>
          </p>
        </div>

        <b-field label="Origen" v-if="pagos.length === 1 && !esPagoSimple(pagos[0].idMetodo) && pagos[0].idMetodo">
          <b-input type="text" name="origen" v-model="origen" placeholder="Origen del pago" required></b-input>
        </b-field>
        <b-switch v-model="esDelivery" @input="manejarEsDelivery" type="is-info">
          ¿Añadir servicio de delivery?
        </b-switch>
        <div style="display: contents" v-if="esDelivery">
          <h4 class="is-size-4 has-text-weight-bold mt-5 has-text-centered">Datos del delivery</h4>
          <b-field class="mt-1" label="Costo del delivery">
            <b-input step="0.01" icon="currency-usd" type="number" placeholder="Costo del delivery"
              v-model="delivery.costo" @input="manejarCostoDelivery" required></b-input>
          </b-field>

          <div class="mb-2" v-if="delivery.costo">
            ({{ formatoMonto(delivery.costo) }})
          </div>

          <b-switch class="mb-3" v-model="delivery.gratis" type="is-info" @input="manejarDeliveryGratis">
            ¿Delivery gratis para el cliente?
          </b-switch>
          <b-field label="Destino del delivery">
            <b-input placeholder="Calle, casa, barrio, ciudad, estado" v-model="delivery.destino" required></b-input>
          </b-field>

          <b-field label="Chofer(es) del delivery">
            <b-autocomplete v-model="busquedaChofer" :data="choferesFiltrados" field="nombre"
              placeholder="Buscar chofer..." open-on-focus @select="agregarChofer" :keep-first="true"
              icon="account-search" clearable>
              <template #empty>No se encontraron choferes</template>
            </b-autocomplete>
          </b-field>

          <section class="tags mt-2">
            <span v-for="(chofer, index) in choferesSeleccionados" :key="chofer.id" class="tag is-primary is-medium">
              {{ chofer.nombre }}
              <button class="delete is-small" @click="eliminarChofer(index)"></button>
            </span>
          </section>

        </div>
        <div v-if="esDelivery && delivery.idChofer && delivery.idChofer.includes('0')">
          <!-- Formulario de nuevo chofer -->
          <!-- ...campos del nuevo chofer... -->
        </div>
        <div style="display: contents;" v-if="esDelivery && delivery.idChofer === '0'">
          <h4 class="is-size-4 has-text-weight-bold mt-5 has-text-centered">Datos del chofer</h4>
          <b-field class="mt-1" label="Nombre del chofer">
            <b-input step="any" icon="account" type="text" placeholder="Ej. Don Paco" v-model="chofer.nombre"
              required></b-input>
          </b-field>
          <b-field label="Teléfono del chofer">
            <b-input step="any" icon="phone" type="number" placeholder="Ej. 2311459874" v-model="chofer.telefono"
              required></b-input>
          </b-field>
          <b-field label="Tipo de identidad">
            <b-select class="wide" placeholder="Seleccionar..." icon="tag-multiple" v-model="chofer.tipo" required>
              <option v-for="tipo in tipos" :key="tipo" :value="tipo">
                {{ tipo }}
              </option>
            </b-select>
          </b-field>
          <b-field label="Cédula/RIF">
            <b-input type="number" placeholder="Ej. 30000000" v-model="chofer.ci" required></b-input>
          </b-field>
        </div>
        <b-field class="mt-3" label="Esta factura se genera en">
          <b-select class="wide" placeholder="Seleccionar..." icon="receipt" v-model="moneda" required
            @input="manejarMoneda">
            <option key="usd" value="usd">Dólares</option>
            <option key="bs" value="bs">Bolívares</option>
          </b-select>
        </b-field>

        <div class="mb-2" v-if="pagado">
          ({{ formatoMonto(pagado) }})
        </div>

        <p class="is-size-1 has-text-weight-bold">Total ${{ formatoMonto(totalVenta) }}</p>
        <p class="is-size-1 has-text-weight-bold">Cambio ${{ formatoMonto(cambio) }}</p>
      </section>
      <footer class="modal-card-foot">
        <b-button label="Cancelar" icon-left="cancel" size="is-medium" @click="$emit('close', 'venta')" />
        <b-button label="Terminar venta" type="is-success" icon-left="check" size="is-medium" native-type="submit" :disabled="enviando" :loading="enviando" />
      </footer>
    </div>
  </form>
</template>
<script>
import BusquedaCliente from '../Clientes/BusquedaCliente'
import { TIPOS_CLIENTE } from '@/consts'
import Utiles from '../../Servicios/Utiles'

export default {
  name: 'DialogoTerminarVenta',
  props: {
    totalVenta: {
      type: [String, Number],
      default: 0
    },
    metodos: {
      type: Array,
      default: () => []
    },
    choferes: {
      type: Array,
      default: () => []
    },
    initialPagado: {
      type: [String, Number],
      default: ''
    },
    initialIdMetodo: {
      type: [String, Number],
      default: null
    },
    initialOrigen: {
      type: String,
      default: ''
    },
    initialCliente: {
      type: Object,
      default: () => ({})
    },
    initialDelivery: {
      type: Object,
      default: () => ({
        costo: null,
        destino: null,
        gratis: false,
        idChofer: null
      })
    },
    initialChofer: {
      type: Object,
      default: () => ({
        nombre: null,
        ci: null,
        tipo: null,
        telefono: null
      })
    },
    initialChoferesSeleccionados: {
      type: Array,
      default: () => []
    },
    // Lo controla el padre mientras la peticion de registro esta en vuelo: deshabilita el
    // boton y evita reenviar (doble clic / doble Enter => dos ventas).
    enviando: {
      type: Boolean,
      default: false
    }
  },
  components: { BusquedaCliente },

  data ()
  {
    const pagoInicial = this.initialIdMetodo
      ? { idMetodo: this.initialIdMetodo, monto: this.initialPagado || this.totalVenta }
      : { idMetodo: null, monto: this.initialPagado || this.totalVenta };

    return {
      moneda: 'usd',
      pagado: this.initialPagado,
      pagos: [pagoInicial],
      origen: this.initialOrigen,
      cliente: { ...this.initialCliente },
      esDelivery: !!(this.initialDelivery && (
        (Array.isArray(this.initialDelivery.idChofer) && this.initialDelivery.idChofer.length > 0) ||
        (typeof this.initialDelivery.idChofer === 'string' && this.initialDelivery.idChofer !== '') ||
        (typeof this.initialDelivery.idChofer === 'number' && this.initialDelivery.idChofer)
      )),
      nuevoChofer: false,
      delivery: {
        ...this.initialDelivery,
        idChofer: Array.isArray(this.initialDelivery?.idChofer)
          ? this.initialDelivery.idChofer
          : (this.initialDelivery?.idChofer !== null && this.initialDelivery?.idChofer !== undefined
            ? [this.initialDelivery.idChofer]
            : []),
        gratis: Boolean(this.initialDelivery?.gratis)
      },
      chofer: { ...this.initialChofer },
      tipos: TIPOS_CLIENTE,
      // Autocomplete choferes
      busquedaChofer: '',
      choferesSeleccionados: [...this.initialChoferesSeleccionados],
    }
  },

  methods: {
    formatoMonto (valor)
    {
      return Utiles.formatoMonto(valor)
    },
    onSeleccionado (cliente)
    {
      this.cliente = cliente
      this.delivery.destino = cliente.direccion
    },

    manejarEsDelivery ()
    {
      this.$emit('actualizar', 'esDelivery', this.esDelivery)
    },

    manejarCostoDelivery ()
    {
      this.$emit('actualizar', 'costoDelivery', this.delivery.costo)
    },

    manejarDeliveryGratis ()
    {
      this.$emit('actualizar', 'deliveryGratis', this.delivery.gratis);
    },

    manejarMoneda ()
    {
      this.$emit('actualizar', 'moneda', this.moneda)
    },

    terminarVenta ()
    {
      // Un clic = un envio. Sin esta guarda, dos clics o dos Enter rapidos disparan dos
      // registros y crean dos ventas.
      if (this.enviando) {
        return
      }

      if (Object.keys(this.cliente).length === 0) {
        this.$buefy.toast.open({
          type: 'is-danger',
          message: 'Debes seleccionar un cliente.'
        })
        return
      }

      // Validate all payment rows have method and amount
      const pagosValidos = this.pagos.filter(p => p.idMetodo && parseFloat(p.monto) > 0)
      if (pagosValidos.length === 0) {
        this.$buefy.toast.open({
          type: 'is-danger',
          message: 'Debes agregar al menos un método de pago con un monto válido.'
        })
        return
      }

      if (this.diferenciaPagos > 0.01) {
        this.$buefy.toast.open({
          type: 'is-danger',
          message: 'El total de los pagos no cubre el monto de la venta. Faltan $' +
            this.formatoMonto(Math.abs(this.diferenciaPagos))
        })
        return
      }

      let payload = {
        tipo: 'venta',
        pagado: this.totalPagosCalculado,
        pagos: pagosValidos,
        cambio: this.cambio,
        cliente: this.cliente,
        moneda: this.moneda,
      }

      if (this.esDelivery) {
        if (this.choferesSeleccionados.length === 0) {
          this.$buefy.toast.open({
            type: 'is-danger',
            message: 'Debes seleccionar al menos un chofer para el delivery'
          })
          return
        }
        payload.delivery = {
          ...this.delivery,
          idChofer: this.choferesSeleccionados.map(c => c.id)
        };
        payload.chofer = this.chofer
      }

      // For single payment, keep backward compat (idMetodo/origen)
      if (pagosValidos.length === 1) {
        const unico = pagosValidos[0]
        if (typeof unico.idMetodo === 'string') {
          payload.simple = unico.idMetodo
        } else {
          payload.idMetodo = unico.idMetodo
          payload.origen = this.origen
        }
      }

      this.$emit('terminar', payload)
    },
    // Autocomplete choferes
    agregarChofer (chofer)
    {
      if (chofer && !this.choferesSeleccionados.some(c => c.id === chofer.id)) {
        this.choferesSeleccionados.push(chofer)
        this.busquedaChofer = ''
      }
    },
    eliminarChofer (index)
    {
      this.choferesSeleccionados.splice(index, 1)
    },

    // Multi-payment helpers
    agregarPago ()
    {
      this.pagos.push({ idMetodo: null, monto: null })
    },
    quitarPago (index)
    {
      this.pagos.splice(index, 1)
    },
    esPagoSimple (idMetodo)
    {
      return typeof idMetodo === 'string'
    }
  },

  computed: {
    esSimple: function ()
    {
      return this.pagos.length === 1 && typeof this.pagos[0].idMetodo === 'string'
    },
    totalPagosCalculado: {
      get ()
      {
        const suma = this.pagos.reduce((acc, p) => acc + (parseFloat(p.monto) || 0), 0)
        return Math.max(0, suma)
      }
    },
    diferenciaPagos ()
    {
      return this.totalPagosCalculado - this.totalVenta
    },
    totalPagosColor ()
    {
      if (this.diferenciaPagos < -0.01) return 'has-text-danger'
      if (this.diferenciaPagos > 0.01) return 'has-text-warning'
      return 'has-text-success'
    },
    cambio ()
    {
      return this.totalPagosCalculado - this.totalVenta;
    },
    // Autocomplete choferes
    choferesFiltrados ()
    {
      return this.choferes.filter(c =>
        !this.choferesSeleccionados.some(sc => sc.id === c.id) &&
        c.nombre.toLowerCase().includes(this.busquedaChofer.toLowerCase())
      )
    }
  },
}
</script>
